import get from 'lodash.get';
import { ADULT, CHILD, INFANT, STUDENT, SENIOR } from '../../domain/age';

const defaultDeparture = {};

export const getGuests = (departure = defaultDeparture) => get(departure, 'guests', []);
export const getVehicles = (departure = defaultDeparture) => get(departure, 'vehicles', []);
export const getCabins = (departure = defaultDeparture) => get(departure, 'cabins', []);
export const getTitle = (departure = defaultDeparture) => get(departure, 'routeName', 'From - To');

const buildDateTime = (dateProp, timeProp) => (departure = defaultDeparture) => {
  const date = get(departure, dateProp);
  const time = get(departure, timeProp);
  if (!date || !time) {
    return null;
  }
  return `${date}T${time}`;
};
export const getDepartureDateTime = buildDateTime('departureDate', 'departureTime');
export const getArrivalDateTime = buildDateTime('arrivalDate', 'arrivalTime');

const guestsByAge = age => (guests = []) => guests.filter(p => p.customerCategory === age).length;
export const getNumberOfAdults = guestsByAge(ADULT);
export const getNumberOfChildren = guestsByAge(CHILD);
export const getNumberOfInfants = guestsByAge(INFANT);
export const getNumberOfStudents = guestsByAge(STUDENT);
export const getNumberOfSeniors = guestsByAge(SENIOR);



// WEBPACK FOOTER //
// ./src/helpers/reservation/index.js